import {
    LEFT_BAR_WIDTH as HORIZONTAL_OFFSET,
    MOBILE_NOTE_DEFAULT_HEIGHT,
    NOTE_DEFAULT_HEIGHT,
    NOTE_COLLAPSE_HEIGHT,
} from '@editor/src/js/constants';
import { CommonColor } from '@editor/src/js/constants/common-color';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';

export class EmptyArea {
    private canvasWrapper: HTMLElement;
    private emptyWrapper: HTMLElement | null = null;
    private emptySlide: HTMLElement | null = null;
    public constructor(canvasWrapper: HTMLElement) {
        this.canvasWrapper = canvasWrapper;
    }

    public update(): void {
        const slideList = this.getAppServices().viewableServiceLayer.selectionService.slides;
        if (slideList.length && this.emptyWrapper) {
            this.canvasWrapper.removeChild(this.emptyWrapper);
            this.emptyWrapper = null;
            this.emptySlide = null;
        } else if (!slideList.length) {
            const isNoteShow = this.getAppServices().viewableServiceLayer.noteAreaManager.show;
            const pcNoteHeight = isNoteShow ? NOTE_DEFAULT_HEIGHT : NOTE_COLLAPSE_HEIGHT;
            const noteAreaInfo = {
                noteAreaHeight: browser.isMobile ? MOBILE_NOTE_DEFAULT_HEIGHT : pcNoteHeight,
                mobileNoteShow: isNoteShow,
            };
            const canvasSize = this.getCanvasSizeHandler().getCanvasSize(false, noteAreaInfo);
            const { width, height, left, top, scale } = canvasSize;
            const { slideWidth, slideHeight } = this.getAppServices().getUiDataService().presentation.props;
            const wrapLeft = Math.round(-(((width + HORIZONTAL_OFFSET) / scale) - (width + HORIZONTAL_OFFSET)) / 2);
            const wrapTop = Math.round(-((height / scale) - height) / 2);
            const emptyDomCss = `
                    width: ${Math.round((width + HORIZONTAL_OFFSET) / scale)}px;
                    height: ${Math.round(height / scale)}px;
                    transform-origin: center;
                    transform: scale(${scale});
                    position: absolute;
                    left: ${wrapLeft}px;
                    top: ${wrapTop}px;
                `;
            const slideCss = `
                    position: absolute;
                    width: ${slideWidth}px;
                    height: ${slideHeight}px;
                    top: ${Math.round(top / scale)}px;
                    left: ${Math.round(left / scale)}px;
                    background-color: ${CommonColor.CCCCCC};
                `;
            if (!this.emptyWrapper) {
                this.emptyWrapper = document.createElement('div');
                this.emptySlide = document.createElement('div');
                this.emptyWrapper.className = 'slide-empty-wrapper';
                this.emptySlide.className = 'slide-empty-inner';
                this.emptyWrapper.appendChild(this.emptySlide);
                this.canvasWrapper.appendChild(this.emptyWrapper);
            }
            (this.emptySlide!).style.cssText = slideCss;
            this.emptyWrapper.style.cssText = emptyDomCss;
        }
    }

    private getCanvasSizeHandler() {
        return this.getAppServices().viewableServiceLayer.canvasService.getCanvasSizeHandler();
    }

    private getAppServices(): IEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IEditorAppServices;
    }
}
